import { push } from 'connected-react-router';
import { actions as authActions, operations as authOperations, utils as authUtils } from '@saucelabs/sl-container-authentication';
import { actions as errorActions } from '@saucelabs/sl-container-error-pages';
import { actions as notifications } from '@saucelabs/sl-container-notifications';
import { createApiAction } from '@saucelabs/sl-util-redux';
import { env } from '@saucelabs/sl-util-config';
import { recordTrack } from '@saucelabs/sl-util-segmentio';
import { cookiesHelper } from '@saucelabs/sl-util-helpers';
import { add } from 'date-fns';

import * as types from './types';

const redirectAfterVerify = (authenticated, dispatch) => {
  const timeoutMs = 5000;

  if (authenticated) {
    setTimeout(() => {
      dispatch(push({
        pathname: '/getting-started',
      }));
    }, timeoutMs);
  } else {
    setTimeout(authUtils.redirectToMainLogin, timeoutMs);
  }
};

export const initialize = createApiAction(
  types.INITIALIZE,
  (payload, meta, dispatch) => (
    Promise.all([
      dispatch(authOperations.getAuthenticatedUser()),
      // hide error page from <LoginRequired />
      dispatch(errorActions.hideErrorPage()),
    ])
      .catch(() => {}) // we don't want the error to be sent to sentry
  ),
);

export const getCookieDomain = () => {
  if (env === 'production') {
    return '.saucelabs.com';
  }

  if (env === 'staging') {
    return '.saucelabs.net';
  }

  return window.location.hostname;
};

export const verifyEmail = ({ authenticated, queryParams }) => (dispatch) => (
  dispatch(authActions.verifyEmail(queryParams))
    .then(() => {
      dispatch(push({
        state: {
          success: true,
        },
      }));
      dispatch(
        recordTrack(
          'User verified email address',
        ),
      );
    })
    .then(() => redirectAfterVerify(authenticated, dispatch))
    .catch(({ response }) => {
      const message = response?.data?.message || 'Your email could not be verified.';
      if (authenticated) {
        dispatch(push({
          pathname: '/dashboard/tests',
        }));
        dispatch(notifications.notifyWarning(message, null, true));
      } else {
        const domain = getCookieDomain();
        const expireDate = add(new Date(), { hours: 2 });

        cookiesHelper.setItem('AM_MESSAGES', message, expireDate, '/', domain, false);
        authUtils.redirectToMainLogin();
      }
    })
);

export const verifyUser = ({ authenticated, queryParams }) => (dispatch) => (
  dispatch(authActions.verifyUser(queryParams))
    .then(() => {
      dispatch(push({
        state: {
          success: 'Welcome to Sauce Labs! Thanks for verifying your email.',
        },
      }));
      dispatch(
        recordTrack(
          'User verified email address',
        ),
      );
    })
    .then(() => redirectAfterVerify(authenticated, dispatch))
    .catch(({ response }) => {
      const message = response?.data?.message || 'Your email could not be verified. Please resend verification email to try again.';
      if (authenticated) {
        dispatch(push({
          pathname: '/dashboard/tests',
        }));
        dispatch(notifications.notifyWarning(message, null, true));
      } else {
        const domain = getCookieDomain();
        const expireDate = add(new Date(), { hours: 2 });

        cookiesHelper.setItem('AM_MESSAGES', message, expireDate, '/', domain, false);
        authUtils.redirectToMainLogin();
      }
    })
);
